<footer class="block bg-gradient-to-b from-gray-100 to-white">
  <hr class="border-b-1 border-gray-200" />
  <div class="flex flex-wrap justify-between items-center">
    <a href="https://soilguard-h2020.eu/">
      <img src="../../../assets/soilguard-logo.png" class="w-24 mx-1">
    </a>
    <div class="flex flex-grow items-center justify-center">
      <img src="../../../assets/flag.jpg" class="w-6 mx-1">
      <div class="text-sm text-gray-600 font-normal text-center">
        This project has received funding from the European Union’s Horizon 2020
        research and innovation programme under grant agreement No. 101000371.
      </div>
    </div>
    <div class="place-self-center mr-2 mt-1">
      <a href="https://www.facebook.com/SOILGUARD/" class="text-gray-600 hover:text-blue-600 mr-1">
        <i class="fab fa-facebook text-md"></i>
      </a>
      <a href="https://twitter.com/SOILGUARD_H2020" class="text-gray-600 hover:text-blue-400 mr-1">
        <i class="fab fa-twitter text-md"></i>
      </a>
      <a href="https://www.tiktok.com/@soilguard?lang=en" class="text-gray-600 hover:text-orange-500 mr-1">
        <i class="fab fa-tiktok text-md"></i>
      </a>
      <a href="https://www.linkedin.com/company/soilguard/" class="text-gray-600 hover:text-blue-500 mr-1">
        <i class="fab fa-linkedin-in text-md"></i>
      </a>
      <a href="https://www.youtube.com/channel/UCo2L5xBEcnND6uRPBgfvzPw" class="text-gray-600 hover:text-red-600 mr-1">
        <i class="fab fa-youtube text-md"></i>
      </a>
    </div>
  </div>
</footer>